import {
  Component,
  ContentChild,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';

import { toBoolean } from '../util/convert';
import { YztTabSetComponent } from './yzt-tabset.component';
export class YztTabComponent implements OnDestroy, OnInit {
public disabled = false;

  position: number | null = null;
  origin: number | null = null;
/**
 * @param {?} value
 * @return {?}
 */
set nzDisabled(value: boolean) {
    this.disabled = toBoolean(value);
  }
/**
 * @return {?}
 */
get nzDisabled(): boolean {
    return this.disabled;
  }

   nzSelect = new EventEmitter();
   nzClick = new EventEmitter();
   nzDeselect = new EventEmitter();
   _tabHeading: TemplateRef<void>;
   _content: TemplateRef<void>;
/**
 * @return {?}
 */
get content(): TemplateRef<void> | null {
    return this._content;
  }
/**
 * @param {?} nzTabSetComponent
 */
constructor(private nzTabSetComponent: YztTabSetComponent) {
  }
/**
 * @return {?}
 */
ngOnInit(): void {
    this.nzTabSetComponent._tabs.push(this);
  }
/**
 * @return {?}
 */
ngOnDestroy(): void {
    this.nzTabSetComponent._tabs.splice(this.nzTabSetComponent._tabs.indexOf(this), 1);
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'yzt-tab',
  template: `
    <ng-template>
      <ng-content></ng-content>
    </ng-template>
  `,
  styles  : [],
  host: {
    '[class.ant-tabs-tabpane]': 'true'
  }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: YztTabSetComponent, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'nzDisabled': [{ type: Input },],
'nzSelect': [{ type: Output },],
'nzClick': [{ type: Output },],
'nzDeselect': [{ type: Output },],
'_tabHeading': [{ type: ContentChild, args: ['nzTabHeading', ] },],
'_content': [{ type: ViewChild, args: [TemplateRef, ] },],
};
}

function YztTabComponent_tsickle_Closure_declarations() {
/** @type {?} */
YztTabComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
YztTabComponent.ctorParameters;
/** @type {?} */
YztTabComponent.propDecorators;
/** @type {?} */
YztTabComponent.prototype.disabled;
/** @type {?} */
YztTabComponent.prototype.position;
/** @type {?} */
YztTabComponent.prototype.origin;
/** @type {?} */
YztTabComponent.prototype.nzSelect;
/** @type {?} */
YztTabComponent.prototype.nzClick;
/** @type {?} */
YztTabComponent.prototype.nzDeselect;
/** @type {?} */
YztTabComponent.prototype._tabHeading;
/** @type {?} */
YztTabComponent.prototype._content;
/** @type {?} */
YztTabComponent.prototype.nzTabSetComponent;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
